import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const defaultUnblockerCallback = ({ location, unblock, history }) => {
  unblock();
  history.push(location);
};

export const useNavigationBlocker = (
  isBlocking = false,
  unblockerCallback = defaultUnblockerCallback,
  beforeUnloadCallback = () => {},
) => {
  const history = useHistory();

  useEffect(() => {
    const beforeunloadHandler = (event) => {
      event.preventDefault();
      event.returnValue = true; // Included for legacy support, e.g. Chrome/Edge < 119

      if (typeof beforeUnloadCallback === 'function') {
        beforeUnloadCallback();
      }
    };

    let unblock;
    if (isBlocking) {
      window.addEventListener('beforeunload', beforeunloadHandler);

      unblock = history.block((location, action) => {
        if (typeof beforeUnloadCallback === 'function') {
          unblockerCallback({ location, action, unblock, history });
        } else {
          defaultUnblockerCallback({ location, action, unblock, history });
        }

        return false;
      });
    }

    return () => {
      if (unblock) {
        unblock();
      }
      window.removeEventListener('beforeunload', beforeunloadHandler);
    };
  }, [beforeUnloadCallback, history, isBlocking, unblockerCallback]);
};
